import Vue from 'vue';
import axios from 'axios';
import { activateMock } from './api.mock';
import store from '../store';

console.log(process.env);

if (process.env.VUE_APP_ACTIVATE_MOCK) {
    console.log('MOCKING');
    activateMock(axios);
}

export const baseURL = (
    process.env.VUE_APP_BACKEND_URL_PREFIX
        ? process.env.VUE_APP_BACKEND_URL_PREFIX
        //: 'https://beta.jobs-in-finland.com'
        : location.origin
);

const apiPrefix = `${baseURL}/api`;
const apiClient = axios.create({
    baseURL: apiPrefix,
});

/* HTTP Error message interceptors */
apiClient.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status === 401) {
        store.dispatch("commitSnackbar", { show: true, message: "Invalid credentials.", timeout: 4000, color: "error" });
    }
    if (error.response.status === 403) {
        console.log(error.response);
        store.dispatch("commitSnackbar", { show: true, message: `You do not have enough permissions for this action. Error: ${error.response.data.type}`, timeout: 4000, color: "error" });
    }
    return Promise.reject(error);
});

/*
 * POST https://<baseURL>/api/private/auth/local/login
 * { identifier, password }
 * => { jwt, userId }
 */
function login(username, password) {
    return apiClient.post('/private/auth/local/login', { identifier: username, password });
}

/*
 * POST https://<baseURL>/api/private/auth/local/reset-with-token
 */
function resetPassword(token, newPassword) {
    return apiClient.post('/private/auth/local/reset-with-token', { token, newPassword });
}

/*
 * POST https://<baseURL>/api/private/auth/local/forgot-password
 */
function forgotPassword(identifier) {
    return apiClient.post('/private/auth/local/forgot-password', { identifier });
}

/*
 * GET https://<baseURL>/api/categories
 * => {id, name, keywords, imageUrl, popularity}[]
 */
function getCategories() {
    return apiClient.get('/categories');
}
/*
 * GET https://<baseURL>/api/areas
 * => {id, name, keywords, imageUrl, popularity}[]
 */
function getAreas() {
    return apiClient.get('/areas');
}
function getLocations() { return getAreas(); }

/*
 * GET https://<baseURL>/api/cities
 * => {id, name, geo: { lat, long }, area: { id, name, finnish, english }, country }[]
 */
function getCities() {
    // TODO: To be implemented
    console.warn("getCities", "NOT IMPLEMENTED YET");
}

/*
 * GET https://<baseURL>/api/tags
 * => {id}[]
 */
function getTags() {
    return apiClient.get('/tags');
}
function getTopics() { return getTags(); }

/*
 * GET https://<baseURL>/api/reasons-to-report
 * => [{id, description}]
 */
function getReasonsToReport() {
    return apiClient.get('/reasons-to-report');
}
/*
 * GET https://<baseURL>/api/reasons-to-hide
 * => {id, description}[]
 */
function getReasonsToHide() {
    return apiClient.get('/reasons-to-hide');
}


//----------------------------------------------------------------
// Public jobs
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/jobs
 * => Job[]
 */
function getJobs(offset, limit) {
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
    };
    return apiClient.get(`/jobs`, { params })
}

/*
 * POST https://<baseURL>/api/public/jobs
 * {Job}
 */
function postJob(data) {
    console.log(data);
    return apiClient.post(`/public/jobs`, data);
}


//----------------------------------------------------------------
// Admin / private jobs
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/private/jobs
 * => Job[]
 */
function getAdminJobs(jwt, offset, limit) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
    };
    return apiClient.get(`/private/jobs`, {
        params,
        headers
    })
}
/*
 * POST https://<baseURL>/api/private/jobs
 * {Job}
 */
function postAdminJob(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/jobs`, data, { headers });
}
/*
 * PUT https://<baseURL>/api/private/jobs/:id
 * {Job}
 */
function putAdminJob(jwt, id, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/jobs/${id}`, data, { headers });
}
/*
 * DELETE https://<baseURL>/api/private/jobs/:id
 */
function deleteAdminJob(jwt, id) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.delete(`/private/jobs/${id}`, { headers });
}

/*
 * Send accepted notification for user submitted job
 * POST https://<baseURL>/api/private/notifications/accept-job
 * {Job}
 */
function postAdminAcceptJob(jwt, job, reviewer) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const data = { job, reviewer: { profile: reviewer } };
    return apiClient.post(`/private/notifications/accept-job`, data, { headers });
}

/*
 * Send rejected notification for user submitted job
 * POST https://<baseURL>/api/private/notifications/reject-job
 * {Job}
 */
function postAdminDeclineJob(jwt, job, reviewer) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const data = { job, reviewer: { profile: reviewer } };
    return apiClient.post(`/private/notifications/reject-job`, data, { headers });
}

//----------------------------------------------------------------
// Public campaigns
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/campaigns
 * => Campaign[]
 */
function getCampaign(id) {
    return apiClient.get(`/campaigns/${id}`)
}

/*
 * GET https://<baseURL>/api/jobs?campaignId=<id>
 * => Job[]
 */
function getJobsForCampaign(campaignId, offset, limit) {
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
        campaignId: campaignId
    };
    return apiClient.get(`/jobs`, {
        params
    });
}

//----------------------------------------------------------------
// Public employers
//----------------------------------------------------------------

/*
 * GET https://<baseURL>/api/employers
 * => Employer[]
 */

function getEmployers() {
    return apiClient.get(`/employers`);
}


//----------------------------------------------------------------
// Admin / private campaigns
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/private/campaigns
 * => Campaign[]
 */
function getAdminCampaigns(jwt, offset, limit) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
    };
    return apiClient.get(`/private/campaigns`, {
        params,
        headers
    })
}
/*
 * POST https://<baseURL>/api/private/campaigns
 * {Campaign}
 */
function postAdminCampaign(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/campaigns`, data, { headers });
}
/*
 * PUT https://<baseURL>/api/private/campaigns/:id
 * {Campaign}
 */
function putAdminCampaign(jwt, id, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/campaigns/${id}`, data, { headers });
}
/*
 * DELETE https://<baseURL>/api/private/campaigns/:id
 */
function deleteAdminCampaign(jwt, id) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.delete(`/private/campaigns/${id}`, { headers });
}

/*
 * GET https://<baseURL>/api/private/campaigns/:id/jobs
 * => { string[] }
 */
function getAdminCampaignJobs(jwt, campaignId) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get(`/private/campaigns/${campaigId}/jobs`, { headers });
}
/*
 * PUT https://<baseURL>/api/private/campaigns/:id/jobs
 * { string[] }
 */
function putAdminCampaignJobs(jwt, campaignId, jobIds) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    console.log(jobIds);
    return apiClient.put(`/private/campaigns/${campaignId}/jobs`, jobIds, { headers });
}

//----------------------------------------------------------------
// Admin / private policies
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/private/policies
 * => Policy[]
 */
function getAdminPolicies(jwt, offset, limit) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
    };
    return apiClient.get(`/private/policies`, {
        params,
        headers
    })
}

function postAdminPolicy(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/policies`, data, { headers });
}

function postAdminPolicies(jwt, data) {
    console.log(data);
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/policies/batch`, data, { headers });
}

function putAdminPolicy(jwt, id, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/policies/${id}`, data, { headers });
}

function deleteAdminPolicy(jwt, id) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.delete(`/private/policies/${id}`, { headers });
}

//----------------------------------------------------------------
// Admin / private employers
//----------------------------------------------------------------
/*
 * GET https://<baseURL>/api/private/employers
 * => Employer[]
 */
function getAdminEmployers(jwt, offset, limit) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    const params = {
        offset: offset ? offset : 0,
        limit: limit ? limit : 5000,
    };
    return apiClient.get(`/private/employers`, {
        params,
        headers
    })
}
/*
 * POST https://<baseURL>/api/private/employers
 * {Employer}
 */
function postAdminEmployers(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/employers`, data, { headers });
}
/*
 * PUT https://<baseURL>/api/private/employers/:id
 * {Employer}
 */
function putAdminEmployers(jwt, id, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/employers/{$id}`, data, { headers });
}
/*
 * DELETE https://<baseURL>/api/private/employers/:id
 */
function deleteAdminEmployers(jwt, id) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.delete(`/private/employers/${id}`, { headers });
}


//----------------------------------------------------------------
// Admin / private pages
//----------------------------------------------------------------
/*
 * POST https://<baseURL>/api/private/content-pages
 * {id, title, subtitle, navTitle, imageUrl, content: { main, side } }[]
 */
function postAdminPages(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post(`/private/content-pages`, data, { headers });
}

/*
 * GET https://<baseURL>/api/private/content-pages
 * => {id, title, subtitle, navTitle, imageUrl, content: { main, side } }[]
 */
function getPages(jwt) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get('/private/content-pages', { headers });

}

/*
 * PUT https://<baseURL>/api/private/content-pages
 * => {id, title, subtitle, navTitle, imageUrl, content: { main, side } }[]
 */
function putPage(jwt, id, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/content-pages/${id}`, data, { headers });
}


//----------------------------------------------------------------
//----------------------------------------------------------------
function postReportJob(jobId, data) {
    return apiClient.post(`/public/jobs/${jobId}/reports`, data);
}

// private/users & private/users/:id/profile & /private/user-profiles
function getUsers(jwt) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get('/private/user-profiles', { headers });
}

function getUser(jwt, userId) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get(`/private/user-profiles/${userId}`, { headers });
}

function postUser(jwt, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.post('/private/auth/local/register', data, { headers });
}

function putUser(jwt, userId, data) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/user-profiles/${userId}`, data, { headers });
}

function getRoles(jwt, userId) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get('/private/access/roles', { headers });
}

function getUserRoles(jwt, userId) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.get(`/private/access/roles/${userId}`, { headers });
}

function putUserRoles(jwt, userId, userRoles) {
    const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
    return apiClient.put(`/private/access/roles/${userId}`, userRoles, { headers });
}

function getStatistics(campaignId) {
    const query = campaignId ? `campaignId=${campaignId}` : '';
    return apiClient.get(`/statistics?${query}`);
}

//----------------------------------------------------------------
// Public contact forms
//----------------------------------------------------------------

/*
 * POST https://<baseURL>/api/contact-form
 * {FormData}
 */
function postContactForm(formData) {
    console.log(formData);
    return apiClient.post(`/public/contact-form`, formData);
}

// Check the state of the system by pinging statistics endpoint
function getState() {
    return apiClient.get('/statistics');
}

export default {
    apiPrefix,
    login,                          // Status: WORKS

    resetPassword,

    forgotPassword,

    getCategories,                  // Status: WORKS

    getAreas,                       // Status: Pending

    getLocations,                   // Status: Pending

    getCities,                      // Status: Pending

    getTags,                        // Status: WORKS

    getReasonsToReport,             // Status: WORKS

    getReasonsToHide,               // Status: WORKS

    getJobs,                        // Status: WORKS

    postJob,                        // Status: Pending

    getAdminJobs,                   // Status: WORKS

    postAdminJob,                  // Status: WORKS

    putAdminJob,                   // Status: WORKS

    deleteAdminJob,                // Status: Pending

    postAdminAcceptJob,

    postAdminDeclineJob,

    getCampaign,                    // Status: Pending

    getJobsForCampaign,             // Status: Pending

    getAdminCampaigns,              // Status: Pending

    postAdminCampaign,             // Status: Pending
    //postCampaign,                 // Status: Pending

    putAdminCampaign,              // Status: Pending

    deleteAdminCampaign,           // Status: Pending

    getAdminCampaignJobs,           // Status: Pending

    putAdminCampaignJobs,           // Status: Pending

    // Policy endpoints
    getAdminPolicies,
    postAdminPolicy,
    postAdminPolicies,
    putAdminPolicy,
    deleteAdminPolicy,

    deleteAdminPolicy,

    getEmployers,

    getAdminEmployers,              // Status: Pending

    postAdminEmployers,             // Status: Pending

    putAdminEmployers,              // Status: Pending

    deleteAdminEmployers,           // Status: Pending

    postAdminPages,                 // Status: Pending

    getPages,                       // Status: Pending

    putPage,                        // Status: Pending

    postReportJob,                  // Status: WORKS

    getUsers,                       // Status: Pending

    getUser,

    postUser,

    putUser,

    getRoles,

    getUserRoles,

    putUserRoles,

    getStatistics,

    postContactForm,

    getState,

};
